import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import * as _ from "lodash";
import ActionEditor from "../../components/Editing/ActionEditor";
import { nameofFactory, getDeck, hasWriteAccess } from "../../utils/utils";
import { EditActions, editActions } from "../../actions/editActions";
import DropdownField from "../../components/Editing/DropdownField";
import {
  getActionEnumOptions,
  getEnumerationItemOptions,
  getOnOffOptions,
  getIoOptions,
  getInputFilterOptions,
  getIoBasicDataTypeOptions
} from "../../utils/pdApiUtils";
import CheckboxField from "../../components/Editing/CheckboxField";
import NumberField from "../../components/Editing/NumberField";
import MenuButton from "../../components/MenuButton/MenuButton";
import { Input, Form } from "semantic-ui-react";
import {
  convertBase
} from "../../utils/utils";

type StateProps = {
  editedStandardAction: Api.StandardAction;
  storedStandardAction: Api.StandardAction;
  pdApi: State.PdApi;
  ioConfig: State.IoConfig;
  activeUser?: Api.User;
};

type DispatchProps = {
  editActions: typeof editActions;
};

type OwnProps = {
  toggleModal: () => void;
  isInput?: boolean;
  actionType: "standardActions" | "ionodePointActions";
};

export type EditStandardActionProps = StateProps & DispatchProps & OwnProps;

type EditStandardActionState = {
  UseBoardAddressDeckChecked: boolean,
  UseBoardAddressSideChecked: boolean,
  UseBoardAddressIndexChecked: boolean
};

const standardActionFields = nameofFactory<Api.StandardAction>();

export class EditStandardAction extends React.Component<EditStandardActionProps, EditStandardActionState> {  
  VALUE_USE_BOARD_DECK = 0;
  VALUE_USE_BOARD_SIDE = 0;
  VALUE_USE_BOARD_INDEX = 0;

state = {
  UseBoardAddressDeckChecked: false,
  UseBoardAddressSideChecked: false,
  UseBoardAddressIndexChecked: false,
  initialEditStandardActionValue : {} as Api.StandardAction
  };

  componentDidUpdate(prevProps: Readonly<EditStandardActionProps>): void {
    if(this.state.initialEditStandardActionValue.id !== this.props.editedStandardAction.id){
      this.setState(prevState => ({
        ...prevState,
        initialEditStandardActionValue : JSON.parse(JSON.stringify(this.props.editedStandardAction))
      }));
    }
    if(prevProps.editedStandardAction.id !== this.props.editedStandardAction.id){
      this.uncheckCheckboxes();
    }
  }

  private uncheckCheckboxes() {
    this.setState(prevState => ({
      ...prevState,
      UseBoardAddressDeckChecked: this.props.editedStandardAction.actionDeck === null,
      UseBoardAddressSideChecked: this.props.editedStandardAction.actionSide === null,
      UseBoardAddressIndexChecked: this.props.editedStandardAction.actionIndex === null
    }));
  }

  componentDidMount(): void {
    this.setState(prevState => ({
      ...prevState,
      initialEditStandardActionValue : JSON.parse(JSON.stringify(this.props.editedStandardAction))
    }));
    this.uncheckCheckboxes();//this runs once, on every first click on the action irrespective of same or different action
  }

  render(): JSX.Element {
    const {
      editedStandardAction,
      storedStandardAction,
      activeUser,
      toggleModal,
      isInput,
      pdApi,
      ioConfig
    } = this.props;
    const {
      UseBoardAddressDeckChecked,
      UseBoardAddressSideChecked,
      UseBoardAddressIndexChecked
    } = this.state;

    // const isNew = !storedStandardAction;
    const eventTypeOptions = getActionEnumOptions(pdApi.eventTypes);
    const eventClassesOptions = getActionEnumOptions(pdApi.eventClasses);
    const actionDeckOptions = getActionEnumOptions(pdApi.decks);
    const actionSideOptions = getActionEnumOptions(pdApi.sides);
    const ioBasicDataTypeOptions = getIoBasicDataTypeOptions(pdApi.ioBasicDataTypes);
    const ioDataTypes = pdApi.ioDataTypes;
    const ioDataSections = pdApi.ioBasicDataTypes.find(
      basicDataType => basicDataType.id === editedStandardAction.dataFormatNavigation.id
    )?.iodataSections;

    const updateDataValue = (
      OldDataValue: number,
      newValue: number,
      mask: number,
      offset: number
    ) => {
      // tslint:disable-next-line: no-bitwise
      const value = (OldDataValue & ~mask) | (newValue << offset);
      return value;
    };
    let DataFormatEditor;
    if (ioDataSections && ioDataSections.length > 0) {
      DataFormatEditor = ioDataSections?.map((dataSection: Api.IodataSection) => {
        let dataSectionInput;
        const mask = dataSection.mask;
        if (dataSection.enumeration) {
          dataSectionInput = (
            <DropdownField
              label=""
              id={dataSection.name}
              // tslint:disable-next-line: no-bitwise
              value={(editedStandardAction.data & mask) >> dataSection.offset}
              options={getEnumerationItemOptions(dataSection.enumeration?.enumerationItems)}
              onChange={(enumValue: number) => {
                const newDataValue = updateDataValue(
                  editedStandardAction.data,
                  enumValue,
                  dataSection.mask,
                  dataSection.offset
                );
                this.props.editActions.setEdited({
                  ...editedStandardAction,
                  data: newDataValue
                });
              }}
            />
          );
        } else {
          dataSectionInput = (
            <NumberField
              id={dataSection.name}
              // tslint:disable-next-line: no-bitwise
              value={(editedStandardAction.data & mask) >> dataSection.offset}
              label=""
              isError={false}
              onChange={(enumValue: number) => {
                const maskInBinary = convertBase(dataSection.mask.toString()).from(16).to(2);
                const maskInBinaryOffset = dataSection.offset === 0 ? maskInBinary : maskInBinary.slice(0,-dataSection.offset);
                const offsetMaskInDecimal = convertBase(maskInBinaryOffset.toString()).from(2).to(10);          
                if(enumValue <= offsetMaskInDecimal) {
                  const newDataValue = updateDataValue(
                    editedStandardAction.data,
                    enumValue,
                    dataSection.mask,
                    dataSection.offset
                  );
                  this.props.editActions.setEdited({
                    ...editedStandardAction,
                    data: newDataValue
                  });
                }
              }}
            />
          );
        }

        return (
          <div key={dataSection.id} className="action-editor-row data-format-row">
            <span className="action-span-space" />
            <label>{dataSection.name}</label>
            {dataSectionInput}
          </div>
        );
      });
    } else {
      DataFormatEditor = (
        <>
          <div className="action-editor-row data-format-row">
            <span className="action-span-space" />
            <label>Data value:</label>

            <NumberField
              id="dataValue"
              // tslint:disable-next-line: no-bitwise
              value={editedStandardAction.data}
              label=""
              isError={false}
              onChange={(enumValue: number) => {
                this.props.editActions.setEdited({
                  ...editedStandardAction,
                  data: enumValue
                });
              }}
            />
          </div>
          <div className="action-editor-row data-format-row">
            <span className="action-span-space" />
            <label>Data type:</label>
            <Form.Field
              className="edit-number-property"
              control={Input}
              type="text"
              id="ioDataType"
              value={
                ioDataTypes.find(ioDataType => ioDataType.value === editedStandardAction.data)
                  ?.enumName ?? ""
              }
              disabled={true}
            />
          </div>
        </>
      );
    }
    /**
     * Builds binary from selected basic data type and action.data to show on UI
     * output : "0b" + "BASIC_DATA_TYPE_AS_BINARY" + "ACTION_DATA_AS_BINARY"
     * @param actionData
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const buildBinaryString = (actionData: number): string => {
      const basicDataTypeEnumValueAsBinary = editedStandardAction.dataFormatNavigation.enumValue.toString(
        2
      );
      const actionDataBinary = editedStandardAction.data.toString(2);
      return (
        "0".repeat(8).substr(basicDataTypeEnumValueAsBinary.length) +
        basicDataTypeEnumValueAsBinary +
        "0".repeat(24).substr(actionDataBinary.length) +
        actionDataBinary
      );
    };
    const resultInBinary = buildBinaryString(editedStandardAction.data);
    const resultParsed = parseInt(resultInBinary.substr(2), 2);
    const resultInHex = resultParsed.toString(16);
    const ioNodePoint = ioConfig.ionodePoints.find(sp => sp.id === editedStandardAction.parentPointId);
    const ioBoardId = ioConfig.selectedIoBoard?.ioBoardId;
    const ioBoard = ioConfig.ioBoards.find(ib => ib.id === ioBoardId);
    const ioNode = ioBoard?.ionodes.find(ion => ion.id === ioNodePoint?.nodeId);
    const network = ioNode?.network;

    this.VALUE_USE_BOARD_DECK = getDeck(network) ?? 0; //Deck For IO Board

    //Deck For Standard Board
    if(window.location.href.includes("standard-boards")){
    const stdNodePoint = ioConfig.standardPoints.find(sp => sp.id === editedStandardAction.parentPointId);
    const selectedStdBoardId = ioConfig.selectedStandardBoard?.standardBoardId;
    const stdBoard = ioConfig.standardBoards.find(ib => ib.id === selectedStdBoardId);
    const stdNode = stdBoard?.standardNodes.find(ion => ion.id === stdNodePoint?.parentNodeId);
    const stdnetwork = stdNode?.network;

    this.VALUE_USE_BOARD_DECK = getDeck(stdnetwork) ?? 0;
    }
    
    //common for IO and Std Board
    this.VALUE_USE_BOARD_SIDE = ioBoard?.side ?? 0;//For std Board, no Side so anyway 0
    this.VALUE_USE_BOARD_INDEX = ioBoard?.index ?? 0;//For std Board, no Index so anyway 0

    return (
      <ActionEditor
        itemName={"Action"}
        originalObject={storedStandardAction}
        editedObject={editedStandardAction}
        hasWritePermission={hasWriteAccess(activeUser, "Lift")}
        isValid={this.isAllFieldsValid()}
        cancel={() => {
          editedStandardAction.dataFormatNavigation.enumValue = this.state.initialEditStandardActionValue.dataFormatNavigation.enumValue;
          editedStandardAction.data = this.state.initialEditStandardActionValue.data;
          storedStandardAction.dataFormatNavigation.enumValue = this.state.initialEditStandardActionValue.dataFormatNavigation.enumValue;
          storedStandardAction.data = this.state.initialEditStandardActionValue.data;
          this.props.editActions.cancelEditing();
          this.uncheckCheckboxes();
        }}
        update={() => {
          this.props.editActions.update(this.props.actionType as Api.OptionsGrud);
          this.uncheckCheckboxes();
        }}
        create={() => {
          this.props.editActions.add(this.props.actionType as Api.OptionsGrud);
          this.uncheckCheckboxes();
        }}
        remove={{ callback: toggleModal }}
      >
        <div className="action-editor-row">
          <DropdownField
            id="eventClass"
            label="eventClass"
            value={editedStandardAction.eventClassEnumNavigation.enumValue}
            options={eventClassesOptions}
            search={true}
            onChange={(index: number) => {
              const eventClass = pdApi.eventClasses.find(ec=>ec.enumValue === index);
              this.props.editActions.setEdited({
                ...editedStandardAction,
                eventClassEnumNavigation: eventClass
              });
            }}
          />

          <DropdownField
            id="eventType"
            label="eventType"
            value={editedStandardAction.eventTypeEnumNavigation.enumValue}
            options={eventTypeOptions}
            search={true}
            onChange={(index: number) => {
              const eventType = pdApi.eventTypes.find(et=>et.enumValue === index);
              this.props.editActions.setEdited({
                ...editedStandardAction,
                eventTypeEnumNavigation: eventType
              });
            }}
          />
        </div>
        <h3>ACTION ADDRESS</h3>
        <div className="action-editor-row">
          <label>Deck</label>
          <DropdownField
            label=""
            id="actionDeck"
            disabled={UseBoardAddressDeckChecked}
            value={!UseBoardAddressDeckChecked ? editedStandardAction.actionDeck ?? this.VALUE_USE_BOARD_DECK : this.VALUE_USE_BOARD_DECK}
            options={actionDeckOptions}
            search={true}
            onChange={(index: number) => {
              this.props.editActions.setEdited({
                ...editedStandardAction,
                actionDeck: index
              });
            }}
          />
          <CheckboxField
            id="UseBoardAddressForDeck"
            label="Use Board Address"
            checked={UseBoardAddressDeckChecked}
            onChange={value => {
              this.props.editActions.setEdited({
                ...editedStandardAction,
                actionDeck: value ? null : storedStandardAction.actionDeck ?? this.VALUE_USE_BOARD_DECK
              });
              this.setState(prevState => ({
                ...prevState,
                UseBoardAddressDeckChecked: !UseBoardAddressDeckChecked
              }));
            }}
          />
        </div>
        <div className="action-editor-row">
          <label>Side</label>
          <DropdownField
            label=""
            id="actionSide"
            disabled={UseBoardAddressSideChecked}
            value={!UseBoardAddressSideChecked ? editedStandardAction.actionSide ?? this.VALUE_USE_BOARD_SIDE : this.VALUE_USE_BOARD_SIDE}
            options={actionSideOptions}//when checkbox clicked, even edited will be set to null so, used ?? operator to show board side in above line, during user activities.
            search={true}
            onChange={(index: number) => {
              this.props.editActions.setEdited({
                ...editedStandardAction,
                actionSide: index
              });
            }}
          />
          <CheckboxField
            id="UseBoardAddressForSide"
            label="Use Board Address"
            checked={UseBoardAddressSideChecked}
            onChange={value => {
              this.props.editActions.setEdited({
                ...editedStandardAction,
                actionSide: value ? null : storedStandardAction.actionSide ?? this.VALUE_USE_BOARD_SIDE
              });//if unchecking - he is aware that he wants to save some value, so used stored value , then if stored value is also null use board value.
              // This will automatically set the dropdown to that value, since we are setting editedStandardAction.actionSide directly in above line
              this.setState(prevState => ({
                ...prevState,
                UseBoardAddressSideChecked: !UseBoardAddressSideChecked
              }));
            }}
          />
        </div>
        <div className="action-editor-row">
          <label>Index</label>
          <NumberField
            id="actionIndex"
            disabled={UseBoardAddressIndexChecked}
            value={!UseBoardAddressIndexChecked ? editedStandardAction.actionIndex ?? this.VALUE_USE_BOARD_INDEX : this.VALUE_USE_BOARD_INDEX}
            label=""
            isError={false}
            onChange={(index: number) => {
              this.props.editActions.setEdited({
                ...editedStandardAction,
                actionIndex: index
              });
            }}
          />
          <CheckboxField
            id="UseBoardAddressForIndex"
            label="Use Board Address"
            checked={UseBoardAddressIndexChecked}
            onChange={value => {
              this.props.editActions.setEdited({
                ...editedStandardAction,
                actionIndex: value ? null : storedStandardAction.actionIndex ?? this.VALUE_USE_BOARD_INDEX
              });
              this.setState(prevState => ({
                ...prevState,
                UseBoardAddressIndexChecked: !UseBoardAddressIndexChecked
              }));
            }}
          />
        </div>
        {(() => {
          const fields = [];
          //revert by uncommenting deck line
          if (editedStandardAction.actionDeck === this.VALUE_USE_BOARD_DECK && !UseBoardAddressDeckChecked) fields.push("Deck");
          if (editedStandardAction.actionSide === this.VALUE_USE_BOARD_SIDE && !UseBoardAddressSideChecked) fields.push("Side");
          if (editedStandardAction.actionIndex === this.VALUE_USE_BOARD_INDEX && !UseBoardAddressIndexChecked) fields.push("Index");

          if (fields.length === 0) return null;

          const fieldList =
            fields.length === 1
              ? fields[0]
              : fields.length === 2
              ? fields.join(" and ")
              : `${fields.slice(0, -1).join(", ")} and ${fields[fields.length - 1]}`;

          return (
            <p className="information">
              {`${fieldList} value${fields.length > 1 ? "s" : ""} match the parent. Select “Use Board Address” and save to inherit future parent’s address updates automatically.`}
            </p>
          );
        })()}
        <h3>ACTION DATA</h3>
        <div className="actionData-border-padding">
          <div className="action-editor-row actionData-field-width">
            <label>Format</label>
            <DropdownField
              label=""
              id="format"
              value={editedStandardAction.dataFormatNavigation.id}
              options={ioBasicDataTypeOptions}
              onChange={(id: number | string) => {
                const filteredData = ioBasicDataTypeOptions.filter(data => data.value === id)[0];
                const enumValue: number = (filteredData?.key as number) ?? 0;
                editedStandardAction.dataFormatNavigation.enumValue = enumValue;
                editedStandardAction.data = 0;
                this.props.editActions.setEdited({
                  ...editedStandardAction,
                  dataFormatNavigation: {
                    ...editedStandardAction.dataFormatNavigation,
                    id: id
                  }
                });
              }}
            />
          </div>
          <div className="actionData-field-width">
            {DataFormatEditor}
          </div>          
          <hr className="actionData-result-line"/>
          <div className="action-editor-row flex-center-aligned">
            <span className="action-span-space" />
            <label >Result</label>
            <span className="action-span-space" />
            <div id="actionDataValueResult">
              {resultParsed + " [0x" + resultInHex + "]"}
            </div>
          </div>
        </div>
        {isInput &&
        <div className="action-editor-row">
          <DropdownField
            id="inputStuckSupervision"
            label="Input Stuck Supervision"
            value={editedStandardAction.inputStuckSupervision ?? 0}
            options={getOnOffOptions()}
            onChange={(value: string | number) => {
              this.props.editActions.setEdited({
                ...editedStandardAction,
                inputStuckSupervision: value
              });
            }}
          /> 
          <DropdownField
            id="ioInputFilterTimes"
            label="Input Filter Time"
            value={editedStandardAction.inputFilterTime ?? 0}
            options={getInputFilterOptions(pdApi.ioOptions)}
            onChange={(value: number | string) => {
              this.props.editActions.setEdited({
                ...editedStandardAction,
                inputFilterTime: value
              });
            }}
          />
        </div>
        }
        <div className="action-editor-row">
          <DropdownField
            id="ioOptions"
            label="Options"
            value={editedStandardAction.options ?? 0}
            options={getIoOptions(pdApi.ioOptions, isInput ? "input" : "output")}
            onChange={(value: number | string) => {
              this.props.editActions.setEdited({
                ...editedStandardAction,
                options: value
              });
            }}
          />
          <div>
            <NumberField
              id="holdTimeWeight"
              value={editedStandardAction.holdOrWeight}
              label={isInput ? "Hold Time" : "Weight"}
              isError={!this.isFieldValid(standardActionFields("holdOrWeight"))}
              onChange={(value: number | string) => {
                this.props.editActions.setEdited({
                  ...editedStandardAction,
                  holdOrWeight: value
                });
              }}
            />
            {!this.isFieldValid(standardActionFields("holdOrWeight")) && <p className="errorMessageMargin">{"Value ranges from 0 to 255"}</p>}
          </div>
        </div>
        {hasWriteAccess(activeUser, "Lift") && (
          <div className="action-editor-delete-row">
            <MenuButton type="Delete" handleOnClick={toggleModal} customText="DELETE ACTION" />
          </div>
        )}
      </ActionEditor>
    );
  }

  private isFieldValid = (field: string): boolean => {
    const { editedStandardAction, isInput } = this.props;
    switch (field) {
      case standardActionFields("holdOrWeight"): {
        if (isInput && editedStandardAction?.holdOrWeight > 255){
          return false;
        } else {
          return true;
        }
      }
      default:
        return true;//means no error
    }
  };

  private isAllFieldsValid = (): boolean => {
    const { editedStandardAction } = this.props;
    const temp = _.keys(editedStandardAction);
    for (const key of temp) {
      if (!this.isFieldValid(key)) {
        return false;
      }
    }
    return true;
  };
}

const mapStateToProps = (state: State.Root) => ({
  editedStandardAction: state.editView.editedObject,
  storedStandardAction: state.editView.storedObject,
  pdApi: state.pdApi,
  ioConfig: state.ioConfig,
  activeUser: state.main.activeUser
});

const mapDispatchToProps = (dispatch: Dispatch<EditActions>) => ({
  editActions: bindActionCreators({ ...editActions }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(EditStandardAction);


